import { Theme } from '../../../../types/shared'
import {
  ChartEventBadgeState,
  IChartEventBadgeProps,
  getChartEventBadgeColors,
  getChartEventBageColors,
} from '../../../utils/chart-events-utils'

export function getChartEventEarningsNegativeSvgString({
  theme = Theme.light,
  state = ChartEventBadgeState.default,
  width,
}: IChartEventBadgeProps) {
  const { outerStroke, innerStroke, innerFill, textFill } = getChartEventBadgeColors({
    theme,
    state,
    colors: getChartEventBageColors('red'),
  })

  // browsers have issue rendering non-straight paths when one have same edge as other,
  // outer stroke line edge is same as inner fill edge and when browser rasterize diagonal line it breaks it down to pixels with variable opacity/color
  // but if there aren't opacity pixels on same place render is correct, due that adding fill solve incorrect color of colliding opacity pixels
  return `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      classname='pointer-events-none block'
      width="${width}"
      height="${width}"
      viewBox="0 0 24 24"
    >
      <path
        d="M2.5 5v13.56a2.5 2.5 0 0 0 1.7 2.37l7 2.33a2.5 2.5 0 0 0 1.6 0l7-2.33a2.5 2.5 0 0 0 1.7-2.37V5A2.5 2.5 0 0 0 19 2.5H5A2.5 2.5 0 0 0 2.5 5Z"
        stroke="${outerStroke}"
        fill="${outerStroke}"
      />
      <path
        d="M4 18.56V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v13.56a1 1 0 0 1-.68.95l-7 2.33a1 1 0 0 1-.64 0l-7-2.33a1 1 0 0 1-.68-.95Z"
        stroke-width="2"
        fill="${innerFill}"
        stroke="${innerStroke}"
      />
      <path d="M8.96 16V7.27h5.47v1.14h-4.15v2.66h3.86v1.12h-3.86v2.68h4.2V16H8.96Z" fill="${textFill}" />
    </svg>
  `
}
